import { guardClient } from '../_axios'

/**
 * カラム削除（配下のタスクも削除）
 * [delete]/tasks/columns/{id}
 */
export type DeleteColumnRequest = {
  id: string
}

export const deleteColumn = async (request: DeleteColumnRequest) => {
  const { id } = request
  const path = '/tasks/columns'
  const response = await guardClient.delete(path + '/' + id)
  return response.data
}
